import { initializeGa } from 'web-shared/lib';
import { config } from './config';

export const initializeGoogleAnalytics = () =>
	initializeGa(config.client.id, config.googleAnalyticsCode);
